import React from 'react';
import classNames from 'classnames';
import SyncRowHandler from '../../TableColumns/SyncRowHandler/SyncRowHandler';
import StandardTableItem from '../StandardTableItem/StandardTableItem';
import RowHandler from '../../TableColumns/RowHandler/RowHandler';
// import { transform } from 'babel-standalone';
require('./TableItem.scss');

class TableItem extends React.Component {
  constructor(props) {
    super(props);
    this.onTouchTap = this.onTouchTap.bind(this);
  }

  onTouchTap(e) {
    // checkbox禁用
    if (!this.props.showChecked && this.props.tableType === 'batchTable') {
      return false;
    }
    if (this.props.onTouchTap) {
      this.props.onTouchTap(e, this.props.row, this.props.index);
    }
  }

  getDestCmp(cmpName, cmp, isContent, prefCmpProps) {
    if (this.props.convertToComponent) {
      return this.props.convertToComponent({
        cmpName: cmpName
        , row: this.props.row
        , columns: this.props.columns
        , index: this.props.index
        , extensionCmp: cmp
        , hasRowHandler: this.props.hasRowHandler
        , onRowTouchTap: this.props.onRowTouchTap
        , isContent: isContent
        , setClickPos: this.props.setClickPos
        , prefCmpProps: prefCmpProps
      });
    }
  }

  filterJs(tpl) {
    const reg = /<(script|style)(.+?)(script|style)>|on([a-zA-Z0-9]+?)=(("|')(.+?)("|')|(.+?)})/igm;
    return tpl.replace(reg, '');
  }

  convertTpl() {
    // let tpl = this.props.tpl;
    // tpl = this.filterJs(tpl);
    // const reg = /{％([a-zA-Z0-9_]+)％}/igm;
    // tpl = tpl.replace(reg,'{this.getDestCmp("$1")}');
    // tpl = tpl.trim();
    // const output = transform(tpl, { plugins: ['transform-react-jsx'] }).code;
    const fn = new Function(['React'], 'return ' + this.props.tpl);
    return fn.apply(this, [React]);
  }

  showCheckBox(showChecked, isChecked) {
    // 'icon-radio-disable': !this.props.disableCheck
    if (!showChecked) {
      return null;
    } else {
      return (
        <div className='checkbox-container' style={{
          width: '0.28rem'
        }}>
          <i className={classNames('icon-radio', {
            'icon-radio-active': isChecked
          })} />
        </div>
      );
    }
  }

  render() {
    const { index, isAndroid
      , row, tpl
      , tableColumn
      , hasAvatars
      , showChecked, checked
      , hasRowHandler, isSyncRowHandler
      , rowButtonList, rowButtonItemTouchTap, onRowTouchTap, setClickPos } = this.props;
    let rowStyle = {};
    let rowCls = '';
    if (tpl) {
      rowCls = classNames('table-list-item tpl-item'
        , 'column-' + (tableColumn || 1)
        , { 'hasCheck': showChecked }
        , { 'extension-tpl-noMainMedia': !hasAvatars }
        , { 'extension-tpl-noAsynRowHandler': (hasRowHandler && isSyncRowHandler) || !hasRowHandler }
        , { 'isSyncRowHandler': hasRowHandler && isSyncRowHandler }
        , { 'extension-isAndroid': isAndroid }
      );
      rowStyle = BSGlobal.application === 'ELearning' && (tableColumn || 1) == 1 ? { marginTop: '12px' } : null;
    } else {
      const { mainInfo, subInfo } = this.props.row;
      rowCls = classNames('table-list-item standard-item'
        , { 'hasCheck': showChecked }
        , { 'hasMedia': mainInfo.showMedia && hasAvatars }
        , { 'hasAsynRowHandler': hasRowHandler }
        , { 'isSyncRowHandler': hasRowHandler && isSyncRowHandler }
        , { 'isAndroid': isAndroid });
    }


    return (
      <li onTouchTap={this.onTouchTap} className={rowCls}
        key={index}
        style={rowStyle} >
        {this.showCheckBox(showChecked, checked)}
        <div className={classNames('table-item-content-container')} >
          {tpl ? this.convertTpl() : <StandardTableItem showChecked={showChecked}
            tableType={this.props.tableType}
            showMedia={row.mainInfo.showMedia && hasAvatars}
            mainInfo={row.mainInfo}
            actions={this.props.actions}
            subInfo={row.subInfo}
            setClickPos={setClickPos}
            index={index} />}
        </div>

        {(hasRowHandler && !showChecked && !isSyncRowHandler && !tpl) ? <RowHandler onRowTouchTap={onRowTouchTap} id={row._id.value} index={index} style={{ position: 'absolute', right: '16px', top: '12px' }} /> : null}
        {!showChecked && isSyncRowHandler ? <SyncRowHandler index={index}
          hasRowHandler={hasRowHandler}
          isSyncRowHandler={isSyncRowHandler}
          rowButtonList={rowButtonList}
          partId={this.props.partId}
          rowButtonItemTouchTap={rowButtonItemTouchTap} />
          : null}
      </li>
    );
  }

}

export default TableItem;



// WEBPACK FOOTER //
// ./src/components/Table_Components/TableItem/TableItem.js